/**
 * 公共常量定义
 */

// 招聘类型常量
export const RECRUITMENT_TYPES = [
  { label: '社招', value: "0" },
  { label: '校招', value: "1" },
  { label: '实习', value: "2" }
]

// 学历常量
export const EDUCATION_LEVELS = [
  { label: '未知', value: 0 },
  { label: '专科', value: 3 },
  { label: '本科', value: 4 },
  { label: '硕士', value: 5 },
  { label: '博士', value: 6 },
  { label: '成人自考', value: 7 }
]

export const getEducationLabel = (value) => {
  const option = EDUCATION_LEVELS.find(opt => opt.value == value)
  return option ? option.label : '不限'
}

// 职位学历要求常量（用于职位发布/编辑表单）
export const POSITION_EDUCATION_OPTIONS = [
  { label: '学历不限', value: 0 },
  { label: '大专及以上', value: 3 },
  { label: '本科及以上', value: 4 },
  { label: '硕士及以上', value: 5 },
  { label: '博士', value: 6 }
]

// 工作性质常量
export const WORK_NATURE_TYPES = [
  { label: '全职', value: 0 },
  { label: '兼职', value: 1 },
  { label: '实习', value: 2 },
  { label: '外包', value: 3 }
]

// 工作经验常量
export const EXPERIENCE_LEVELS = [
  { label: '不限', value: 0 },
  { label: '1年以下', value: 1 },
  { label: '1-3年', value: 2 },
  { label: '3-5年', value: 3 },
  { label: '5-10年', value: 4 },
  { label: '10年以上', value: 5 }
]

// 职位类型常量
export const POSITION_CATEGORIES = [
  { label: '后端开发', value: '后端开发' },
  { label: '前端/移动开发', value: '前端/移动开发' },
  { label: '测试', value: '测试' },
  { label: '运维/技术支持', value: '运维/技术支持' },
  { label: '产品经理', value: '产品经理' },
  { label: '算法工程师', value: '算法工程师' },
  { label: '化工/能源/环保', value: '化工/能源/环保' }
]

// 城市常量
export const CITIES = [
  { label: '北京', value: '北京' },
  { label: '上海', value: '上海' },
  { label: '深圳', value: '深圳' },
  { label: '广州', value: '广州' },
  { label: '杭州', value: '杭州' },
  { label: '南京', value: '南京' },
  { label: '成都', value: '成都' },
  { label: '武汉', value: '武汉' }
]

// 时间范围常量
export const TIME_RANGE_OPTIONS = [
  { key: 'today', label: '今天', value: 1 },
  { key: 'oneWeek', label: '一周内', value: 2 },
  { key: 'oneMonth', label: '一月内', value: 3 },
  { key: 'sixMonths', label: '半年内', value: 4 }
]

// 消息状态常量
export const MESSAGE_STATUS_OPTIONS = [
  { key: 'unread', label: '未读', value: 0 },
  { key: 'read', label: '已读', value: 1 }
]

// 工作性质常量
export const WORK_NATURE_OPTIONS = [
  { key: 'social', label: '社招', value: 0 },
  { key: 'campus', label: '校招', value: 1 },
  { key: 'intern', label: '实习', value: 2 }
]

// 面试时间常量
export const INTERVIEW_TIME_OPTIONS = [
  { label: '今天', value: '0' },
  { label: '3天内', value: '1' },
  { label: '一周内', value: '2' },
  { label: '一月内', value: '3' }
]

// 默认岗位分类常量
export const DEFAULT_POSITION_CATEGORIES = [
  { id: 1, name: "前端" },
  { id: 2, name: "后端" },
  { id: 3, name: "产品" },
  { id: 4, name: "算法/大模型" },
  { id: 5, name: "互联网" }
]

// 薪资展示：start/end 均有且 start 不包含“天”则展示 K 区间，否则仅展示 start；都无则“面议”
export const formatSalary = (start, end, month) => {
  const s = start != null ? String(start) : ''
  const e = end != null ? String(end) : ''
  const m = month != null && month !== '' ? String(month) : ''
  if (s && e && !s.includes('天')) {
    return `${s}K-${e}K/月${m ? ` * ${m}月` : ''}`
  } else if (s) {
    return s
  }
  return null
}



const workMap = new Map()
WORK_NATURE_OPTIONS.forEach(item => {
    workMap.set(item.value, item.label)
})

export const WORK_NATURE_MAP = workMap